import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialogWarp" }
const _hoisted_2 = { class: "ultitle" }
const _hoisted_3 = {
  key: 0,
  class: "tips"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionCircleFilled = _resolveComponent("QuestionCircleFilled")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "noneFooterBorder",
    visible: _ctx.visible,
    "destroy-on-close": true,
    "ok-button-props": _ctx.okButtonProps,
    "ok-text": _ctx.okText,
    onCancel: _ctx.closeModel,
    onOk: _ctx.sureChangeModelClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_2, [
            _createVNode(_component_QuestionCircleFilled, { class: "modal-icon-text" }),
            (_ctx.type === 'del')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.record.num > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.record.licensePlate || _ctx.record.vin) + "仍有员工，是否继续删除？ ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" 确认 删除该车辆？ ")
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" 确认" + _toDisplayString(_ctx.stateType ? '启用': '停用') + " " + _toDisplayString(_ctx.record.licensePlate || _ctx.record.vin) + "？ ", 1),
                  (!_ctx.stateType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 如若需要，可以随时再次启用 "))
                    : _createCommentVNode("", true)
                ], 64))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "ok-button-props", "ok-text", "onCancel", "onOk"]))
}